"use client";

import { useCurrentSource } from "@/hooks/useCurrentSource";

interface ProfileShape {
  user?: {
    safe_address?: string | null;
    deposit_wallet_address?: string | null;
    wallet_address?: string | null;
    solana_address?: string | null;
  };
}

/**
 * Truncated wallet address shown under the user header in the mobile
 * menu. The address picked depends on the current trading source so
 * the user sees the wallet they'd actually deposit into.
 *
 *  - polymarket: deposit (Phase 1) → safe (legacy) → EOA (last resort).
 *    Mirrors backend resolveTradingWallet().
 *  - kalshi: solana_address.
 *  - predict: wallet_address (BSC EOA).
 *  - hyperliquid: EOA, NOT the master account. The EOA is what users
 *    must send USDC to for deposits; transfers to the master would
 *    get lost.
 */
export function MobileMenuWalletAddress({ profile }: { profile: ProfileShape | null }) {
  const currentSource = useCurrentSource();
  const u = profile?.user;
  if (!u) return null;
  let addr: string | null;
  switch (currentSource) {
    case "polymarket":
      addr = u.deposit_wallet_address || u.safe_address || u.wallet_address || null;
      break;
    case "kalshi":
      addr = u.solana_address || null;
      break;
    case "predict":
      addr = u.wallet_address || null;
      break;
    case "hyperliquid":
      addr = u.wallet_address || null;
      break;
    default:
      addr = u.deposit_wallet_address || u.safe_address || u.wallet_address || null;
  }
  if (!addr) return null;
  return (
    <p className="text-[11px] font-mono text-gray-400 dark:text-gray-500">
      {addr.slice(0, 6)}...{addr.slice(-4)}
    </p>
  );
}
